import { render, staticRenderFns } from "./LevyCreateOrUpdate.vue?vue&type=template&id=2042dda0&"
import script from "./LevyCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./LevyCreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./LevyCreateOrUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports